import {gql} from '@apollo/client'

export const GET_ALL_USER_DEDUCTIONS_TYPE = gql`
  query allCommissionDeductionType(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $name: String
    $name_Icontains: String
    $deductionType: String
  ) {
    allCommissionDeductionType(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      name: $name
      name_Icontains: $name_Icontains
      deductionType: $deductionType
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          name
          deductionType
          value
        }
      }
    }
  }
`
